import { Link } from '@routable/gross-ds';
import React from 'react';
import { Text, WhiteSpace } from 'components';
import helpDocs from 'helpers/helpDocs';
import './FeesChargedSeparatelyWarning.scss';
const FeesChargedSeparatelyWarning = () => (React.createElement("div", { className: "fees-charged-separately-warning" },
    React.createElement(Text.Regular, null, "Fees are charged separately from the bill amount."),
    React.createElement(WhiteSpace, null),
    React.createElement(Link, { href: helpDocs.UNDERSTANDING_ROUTABLE_FEES, openInNewTab: true }, "Learn more about transaction fees \u2197")));
export default FeesChargedSeparatelyWarning;
